import { useGetTagValueQuery } from '@/api/tags.api'
import { TIME } from '@/constants/time'
import { useRealtimeStore } from '@/store/realtime.store'
import { useTagSubscription } from './useWebSocket'

export interface LiveTagValue {
  value: number | null
  quality: string
}

/**
 * Resolve a tag's current numeric value: prefers the realtime WebSocket value,
 * falls back to a polled GET /value. Subscribes for the component's lifetime.
 */
export function useLiveTagValue(tagId: string): LiveTagValue {
  useTagSubscription(tagId)
  const live = useRealtimeStore((s) => s.tagValues.get(tagId))
  const { data } = useGetTagValueQuery(tagId, {
    pollingInterval: TIME.TAG_REFRESH_MS,
    skip: Boolean(live),
  })

  const raw = live?.value ?? data?.value ?? null
  return {
    value: typeof raw === 'number' ? raw : null,
    quality: live?.quality ?? data?.quality ?? 'unknown',
  }
}
